export type AllowanceApiEndpoints = {
  GET_ALLOWANCES: string;
  UPDATE_ALLOWANCE: string;
  CREATE_ALLOWANCE: string;
  DELETE_ALLOWANCE: string;
};

export const ALLOWANCE_API_ENDPOINTS: AllowanceApiEndpoints = {
  GET_ALLOWANCES: "/api/Allowance/getAllowancesByWbsEntryId/{wbsEntryId}",
  UPDATE_ALLOWANCE: "/api/Allowance/{allowanceId}",
  CREATE_ALLOWANCE: "/api/Allowance",
  DELETE_ALLOWANCE: "/api/Allowance/{allowanceId}",
};
